import React from 'react';
import { motion } from 'framer-motion';
// Inline SVG illustrations — 0 KB network cost, instant render, crisp at any size.
// Tuned for the small 80x80 viewBox used by the compact card style.
const illustrations: Record<string, JSX.Element> = {
  V1: <svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-367">
      <rect x="10" y="16" width="60" height="48" rx="3" fill="#FAF7F2" stroke="#C8A664" strokeWidth="2" data-id="element-368" />
      <path d="M14 32 Q28 24 42 32 T68 30" stroke="#C8A664" strokeWidth="1.5" strokeLinecap="round" strokeDasharray="3 3" fill="none" data-id="element-369" />
      <path d="M14 48 Q28 40 42 48 T68 46" stroke="#C8A664" strokeWidth="1.5" strokeLinecap="round" strokeDasharray="3 3" fill="none" data-id="element-370" />
      <circle cx="22" cy="28" r="3" fill="#0F1B3D" data-id="element-371" />
      <circle cx="42" cy="40" r="3" fill="#C8A664" data-id="element-372" />
      <circle cx="60" cy="32" r="4" fill="#DC2626" data-id="element-373" />
      <path d="M58 31l1.5 1.5 3-3.5" stroke="#FAF7F2" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none" data-id="element-374" />
    </svg>,
  V2: <svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-375">
      <rect x="22" y="12" width="28" height="56" rx="2" fill="#FAF7F2" stroke="#C8A664" strokeWidth="2" data-id="element-376" />
      <line x1="40" y1="22" x2="40" y2="60" stroke="#C8A664" strokeWidth="1.5" strokeDasharray="3 3" data-id="element-377" />
      <circle cx="46" cy="42" r="2" fill="#C8A664" data-id="element-378" />
      <g transform="rotate(-15 50 42)" data-id="element-379">
        <circle cx="55" cy="42" r="4" stroke="#C8A664" strokeWidth="2.5" fill="none" data-id="element-380" />
        <rect x="59" y="40" width="14" height="4" fill="#C8A664" data-id="element-381" />
        <rect x="70" y="44" width="3" height="5" fill="#C8A664" data-id="element-382" />
      </g>
    </svg>,
  V3: <svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-383">
      <circle cx="20" cy="22" r="5" fill="#0F1B3D" data-id="element-384" />
      <circle cx="60" cy="22" r="5" fill="#C8A664" data-id="element-385" />
      <circle cx="40" cy="40" r="6" fill="#C8A664" data-id="element-386" />
      <circle cx="20" cy="58" r="5" fill="#C8A664" data-id="element-387" />
      <circle cx="60" cy="58" r="5" fill="#0F1B3D" data-id="element-388" />
      <line x1="20" y1="22" x2="40" y2="40" stroke="#C8A664" strokeWidth="2" data-id="element-389" />
      <line x1="60" y1="22" x2="40" y2="40" stroke="#C8A664" strokeWidth="2" data-id="element-390" />
      <line x1="40" y1="40" x2="20" y2="58" stroke="#C8A664" strokeWidth="2" data-id="element-391" />
      <line x1="40" y1="40" x2="60" y2="58" stroke="#C8A664" strokeWidth="2" data-id="element-392" />
      <circle cx="40" cy="40" r="2" fill="#0F1B3D" data-id="element-393" />
    </svg>,
  V4: <svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-394">
      <line x1="10" y1="64" x2="72" y2="64" stroke="#C8A664" strokeWidth="1.5" data-id="element-395" />
      <line x1="10" y1="64" x2="10" y2="14" stroke="#C8A664" strokeWidth="1.5" data-id="element-396" />
      <path d="M14 30 L28 40 L38 55 L48 45 L58 30 L70 22" stroke="#C8A664" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none" data-id="element-397" />
      <circle cx="38" cy="55" r="4" fill="#DC2626" data-id="element-398" />
      <circle cx="70" cy="22" r="3.5" fill="#C8A664" data-id="element-399" />
      <path d="M70 22 L73 16 L67 16 Z" fill="#C8A664" data-id="element-400" />
    </svg>,
  V5: <svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-401">
      <circle cx="40" cy="32" r="11" fill="#C8A664" data-id="element-402" />
      <path d="M14 50 Q26 44 40 50 T66 50 L66 66 L14 66 Z" fill="#FAF7F2" stroke="#C8A664" strokeWidth="1.5" data-id="element-403" />
      <line x1="40" y1="8" x2="40" y2="14" stroke="#C8A664" strokeWidth="2" strokeLinecap="round" data-id="element-404" />
      <line x1="22" y1="18" x2="26" y2="22" stroke="#C8A664" strokeWidth="2" strokeLinecap="round" data-id="element-405" />
      <line x1="58" y1="18" x2="54" y2="22" stroke="#C8A664" strokeWidth="2" strokeLinecap="round" data-id="element-406" />
      <line x1="14" y1="32" x2="20" y2="32" stroke="#C8A664" strokeWidth="2" strokeLinecap="round" data-id="element-407" />
      <line x1="60" y1="32" x2="66" y2="32" stroke="#C8A664" strokeWidth="2" strokeLinecap="round" data-id="element-408" />
    </svg>,
  V6: <svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-409">
      <path d="M40 64 C 18 50, 12 36, 20 26 C 28 18, 38 22, 40 30 C 42 22, 52 18, 60 26 C 68 36, 62 50, 40 64 Z" fill="#C8A664" data-id="element-410" />
      <rect x="26" y="38" width="28" height="9" rx="1.5" fill="#FAF7F2" transform="rotate(-15 40 42)" data-id="element-411" />
      <line x1="29" y1="40" x2="51" y2="40" stroke="#C8A664" strokeWidth="1" transform="rotate(-15 40 42)" data-id="element-412" />
      <line x1="29" y1="44" x2="51" y2="44" stroke="#C8A664" strokeWidth="1" transform="rotate(-15 40 42)" data-id="element-413" />
    </svg>
};
const volumes = [{
  number: 'V1',
  title: 'El mapa del territorio',
  description: 'La base de evaluación que nadie te enseña.'
}, {
  number: 'V2',
  title: 'La puerta que no se abre sola',
  description: 'Trabajar la motivación sin confrontar.'
}, {
  number: 'V3',
  title: 'Reescribir el circuito',
  description: 'Herramientas cognitivo-conductuales en lenguaje de campo.'
}, {
  number: 'V4',
  title: 'Cuando cae de nuevo',
  description: 'Trabajar la recaída sin que destruya el proceso.'
}, {
  number: 'V5',
  title: 'Más allá de la consulta',
  description: 'Acompañar la reconstrucción de la vida cotidiana.'
}, {
  number: 'V6',
  title: 'El que cuida también necesita cuidado',
  description: 'Sostener tu práctica sin quemarte.'
}];
export function Volumes() {
  return <section className="py-8 md:py-16 px-4" data-id="element-414">
      <div className="max-w-2xl mx-auto" data-id="element-415">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-6 md:mb-8" data-id="element-416">
          <div className="inline-block bg-navy-dark text-cream-bg px-3 py-0.5 md:py-1 rounded-full text-[10px] md:text-xs font-bold mb-2 md:mb-3" data-id="element-417">
            TU HOJA DE RUTA
          </div>
          <h2 className="font-serif text-2xl md:text-4xl font-bold text-navy-dark mb-1 md:mb-2" data-id="element-418">
            Los 6 Volúmenes
          </h2>
          <p className="text-sm md:text-base text-gray-700" data-id="element-419">
            Del primer contacto al cierre — paso a paso
          </p>
        </motion.div>

        <div className="space-y-2 md:space-y-2.5 mb-5 md:mb-6" data-id="element-420">
          {volumes.map((volume, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.04
        }} whileHover={{
          x: 3
        }} className="group bg-cream-light rounded-lg border border-gold/20 hover:border-gold/60 hover:shadow-md transition-all relative flex items-stretch overflow-hidden cursor-default" data-id="element-421">
              <div className="flex-shrink-0 w-14 md:w-20 bg-navy-dark flex flex-col items-center justify-center relative px-1" aria-hidden="true" data-id="element-422">
                <div className="absolute inset-0 bg-gradient-radial from-gold/20 to-transparent" data-id="element-423" />
                <div className="w-9 h-9 md:w-12 md:h-12 relative z-10" data-id="element-424">
                  {illustrations[volume.number]}
                </div>
                <div className="font-serif text-[9px] md:text-xs font-bold text-gold mt-0.5 relative z-10 leading-none" data-id="element-425">
                  {volume.number}
                </div>
              </div>

              <div className="flex-1 py-2 md:py-3 px-3 md:px-4 flex flex-col justify-center" data-id="element-426">
                <h3 className="font-bold text-navy-dark text-xs md:text-sm leading-tight mb-0.5" data-id="element-427">
                  {volume.title}
                </h3>
                <p className="text-gray-600 text-[10px] md:text-xs leading-snug" data-id="element-428">
                  {volume.description}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="bg-gold/10 border-2 border-gold p-2.5 md:p-4 rounded-lg text-center" data-id="element-429">
          <p className="font-bold text-navy-dark text-xs md:text-base" data-id="element-430">
            +120 PÁGINAS DE HERRAMIENTAS LISTAS PARA USAR
          </p>
        </motion.div>
      </div>
    </section>;
}